<div class="modal__content">
  <p>{{config.data.content}}</p>
  <p>{{ config.data.note | translate}}</p>
  <div *ngIf="config.data.showPreferenceOption">
    <label for="unassign-confirmation-modal-checkbox" class="checkbox">
      <input id="unassign-confirmation-modal-checkbox" type="checkbox" class="checkbox__input" [(ngModel)]="rememberPref"
             [ngClass]="{'checkbox-selected': rememberPref}">
      <span id="remember_label" class="checkbox__label">{{ 'assignments.rememberPreferenceMsg' | translate}}</span>
    </label>
  </div>
</div>

<div class="flex flex--row flex--nowrap flex--middle flex--right u-p+">
  <span>
    <button id="archived-workitem-cancel-button"
            type="button"
            class="button button--tertiary"
            (click)="onClose(false); $event.stopPropagation()"
            tabindex="2"
            [innerHTML]="'label.no' | translate">
    </button>
  </span>
  <span class="u-pl-">
    <button id="archived-workitem-yes-button"
            class="button"
            (click)="onClose(true); $event.stopPropagation()"
            tabindex="1"
            [innerHTML]="'label.yes' | translate">
    </button>
  </span>
</div>
